import React, { Component } from "react";
import { connect } from "react-redux";
import { getUserToken, scrollToComponent } from "../shared/utils";
import { receiveOffers, isNewUser, receiveBanks } from "../actions";
import Button from "../../shared/button/button";
import AccountLoginOffer from "../components/account-details/template/AccountLoginOffer";
import AccountBankDetails from "../components/account-details/template/AccountBankDetails";
import AccountCreditCard from "../components/account-details/template/AccountCreditCard";
import { getBanks } from "../shared/requests-api";
import Select from "./../../shared/Select/Select";
import AccountLink from "../components/account-details/template/AccountLink";
import { bindActionCreators } from "redux";
import { getRelationshipsParticipant } from "./../actions/account-link";
import Loading from "../../shared/Loading/Loading";
import { isMobile } from "../../../js/components/searchform/utils/common";

class AccountDetails extends Component {
	constructor() {
		super();
		this.state = {
			currentView: 1,
			hasAccountLink: false,
			filterOptionSelected: { label: "Programa de fidelidade", value: 1 }
		};
	}

	componentDidMount() {
		const {
			receiveBanks,
			getRelationshipsParticipant,
			loadingParticipant,
			typePhoneLatam
		} = this.props;

		if (!loadingParticipant) {
			getRelationshipsParticipant();
		}

		getBanks(getUserToken())
			.then(response => {
				if (self._unmounted) return;
				receiveBanks(response.data);
			})
			.catch(error => {
				console.log("Erro ao carregar bancos ");
			});

		this.handleProps(this.props);

		if (localStorage.getItem("editBankSelected") === "1") {
			this.setState({
				currentView: 2,
				filterOptionSelected: { label: "Dados Bancários", value: 2 }
			});
		}
		if (localStorage.getItem("editCardSelected") === "1") {
			this.setState({
				currentView: 3,
				filterOptionSelected: { label: "Cartão de crédito", value: 3 }
			});
		}
		localStorage.setItem("editBankSelected", "0");
		localStorage.setItem("editCardSelected", "0");
	}

	componentWillReceiveProps(nextProps) {
		this.handleProps(nextProps);
	}

	handleProps(props) {
		const { hideLogin, hasAccountLink, currentView } = this.state;
		const {
			error,
			data,
			dataRelationshipParticipant,
			badgeCountPendent,
			loadingParticipant
		} = props;

		let params = {};

		if (
			!hideLogin &&
			(error ||
				(data && data.offers.length == 0) ||
				(data && data.offers.length == 1 && data.offers[0].fidelity.name == "Amigo"))
		) {
			params.hideLogin = true;
			params.currentView = this._currentView || 2;
		}

		if (dataRelationshipParticipant && dataRelationshipParticipant.length) {
			params.hasAccountLink = true;

			if (badgeCountPendent) {
				params.currentView = 4;
				this._currentView = 4;
			}
		}

		this.setState(params);
	}

	componentWillUnmount() {
		this._unmounted = true;
	}

	renderView() {
		const { typePhoneLatam } = this.props;
		const { currentView } = this.state;

		switch (currentView) {
			case 1:
				return <AccountLoginOffer typePhoneLatam={typePhoneLatam} />;
			case 2:
				return <AccountBankDetails />;
			case 3:
				return <AccountCreditCard />;
			case 4:
				return <AccountLink />;
		}
	}

	render() {
		const { currentView, hideLogin, filterOptionSelected, hasAccountLink } = this.state;
		const { loadingParticipant } = this.props;

		const filterOptions = [
			{ label: "Programa de fidelidade", value: 1 },
			{ label: "Dados bancários", value: 2 },
			{ label: "Cartão de crédito", value: 3 },
			this.state.hasAccountLink && { label: "Conta Família", value: 4 }
		];

		return (
			<React.Fragment>
				<div className="account-details-page">
					<div className="panel-component account-details">
						<div className="col-xs-16 account-details--filter">
							<h1 className="account-details--header">Dados de Cadastro</h1>
							<p className="account-details--header-info">
								Selecione o tipo de informação que deseja alterar ou excluir:
							</p>
							{loadingParticipant && !hasAccountLink ? (
								<Loading />
							) : (
								<>
									{!hideLogin && (
										<Button
											onClick={e => this.setState({ currentView: 1 })}
											className={`hidden-xs hidden-sm ${
												currentView === 1 ? "active-tab-active" : "tab-normal"
											}`}
											data-action="account-details-fidelity"
										>
											Programa de fidelidade
										</Button>
									)}
									<Button
										onClick={e => this.setState({ currentView: 2 })}
										className={`hidden-xs hidden-sm ${
											currentView === 2 ? "active-tab-active" : "tab-normal"
										}`}
										data-action="account-details-bank-details"
									>
										Dados bancários
									</Button>
									<Button
										onClick={e => this.setState({ currentView: 3 })}
										className={`hidden-xs hidden-sm ${
											currentView === 3 ? "active-tab-active" : "tab-normal"
										}`}
										data-action="account-details-credit-card"
									>
										Cartão de crédito
									</Button>
									{hasAccountLink && (
										<Button
											onClick={e => this.setState({ currentView: 4 })}
											className={`hidden-xs hidden-sm ${
												currentView === 4 ? "active-tab-active" : ""
											}`}
											data-action="account-details-accountsGroup"
										>
											Conta Família
										</Button>
									)}
									<div
										className="col-xs-16 hidden-md hidden-lg account-details--filter-select"
										onClick={
											isMobile() && (() => scrollToComponent(".account-details--filter-select"))
										}
									>
										<div className="row">
											<div className="v-center-columns">
												<Select
													id="filter-select"
													selected={filterOptionSelected}
													onChange={filterOptionSelected =>
														this.setState({
															filterOptionSelected: filterOptionSelected,
															currentView: filterOptionSelected.value
														})
													}
													options={filterOptions}
													name="filter-select"
													data-action="account-details-tab-select"
												/>
											</div>
										</div>
									</div>
								</>
							)}
						</div>

						{this.renderView()}
					</div>
				</div>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => ({
	data: state.offers.data,
	error: state.offers.error,
	dataRelationshipParticipant: state.accountLink.dataRelationshipParticipant,
	loadingParticipant: state.accountLink.isLoading.getRelationshipsParticipant,
	badgeCountPendent: state.accountLink.badgeCountPendent
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			getRelationshipsParticipant,
			receiveBanks: banks => receiveBanks(banks)
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(AccountDetails);
